import { Empty } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import BwgButton from '../../../atoms/Button';

const DEFAULT_MESSAGE = 'Não foi possível carregar os dados. Tente novamente.';

// Mesma regra do services/util/error-handler: mensagens de erros 4xx vêm do backend e são exibíveis
export function resolveErrorMessage(error) {
  const statusCode = error?.response?.data?.statusCode ?? error?.response?.data?.status;
  const backendMessage = error?.response?.data?.message;
  if (backendMessage && statusCode >= 400 && statusCode < 500) {
    return backendMessage;
  }
  return DEFAULT_MESSAGE;
}

function LoadError({ error, onRetry }) {
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={resolveErrorMessage(error)}
    >
      <BwgButton onClick={onRetry}>Tentar novamente</BwgButton>
    </Empty>
  );
}

LoadError.propTypes = {
  error: PropTypes.shape({
    response: PropTypes.shape({
      data: PropTypes.shape({
        status: PropTypes.number,
        statusCode: PropTypes.number,
        message: PropTypes.string,
      }),
    }),
  }),
  onRetry: PropTypes.func.isRequired,
};

LoadError.defaultProps = {
  error: undefined,
};

export default LoadError;
